module.exports = __webpack_public_path__ + "static/media/alicilar-logo.ea3d8d6b.png";